<script>
import { mapState } from 'vuex';
import Attr from './Attr.vue';
import ArtworkImage from './ArtworkImage.vue';
import ArtworkSidebarAccordion from './ArtworkSidebarAccordion.vue';
import ArtworkSidebarPreviewImage from './ArtworkSidebarPreviewImage.vue';
import TextNoteExtract from './TextNoteExtract.vue';
import artworkDetailsMixin from 'mixins/artworkDetailsMixin.js';

import applyHighlights from 'lib/applyHighlights.js';
import { partialStrings, unavailableImage } from 'config';
import template from '../../views/partials/single/nonseparable_details.html';

export default {
  data() {
    return {
      partial: partialStrings,
    };
  },
  components: {
    Attr,
    ArtworkImage,
    ArtworkSidebarAccordion,
    ArtworkSidebarPreviewImage,
    TextNoteExtract,
  },
  mixins: [artworkDetailsMixin],
  template,
  props: ['artwork', 'rawArtwork', 'activeHeader'],
  computed: {
    ...mapState('artworks', ['images', 'currentImage']),
    ...mapState('auth', ['currentUser']),
    artistNotes() {
      return this.notes ? this.notes.header_artist : [];
    },
    artworkNotes() {
      return this.notes ? this.notes.header_artwork : [];
    },
    cartNotes() {
      return this.notes ? this.notes.header_cart : [];
    },
    isImageNotAvailable() {
      return this.artwork.image_unavailable;
    },
    imageNotAvailable() {
      return unavailableImage.main[this.artwork.image_unavailable];
    },
    scopedImages() {
      if (this.activeHeader) {
        return this.images;
      } else {
        return this.artwork.imageSet.headers;
      }
    },
    highlightedImages() {
      if (!this.artwork.highlights) return this.scopedImages;
      return this.scopedImages.map((i) => applyHighlights(i, this.artwork.highlights));
    },
    image() {
      const imageIndex = this.activeHeader ? this.currentImage || 0 : 0;
      return this.highlightedImages[imageIndex] || {};
    },
  },
  methods: {
    isNoteAvailable({ author_in_common, recap_multi }) {
      return author_in_common != 'a' || recap_multi != 'yes';
    },
    isAuthorInCommon({ author_in_common, recap_multi }) {
      return author_in_common != 'a' || recap_multi != 'yes';
    },
    setHeader() {
      const query = Object.assign({}, this.$route.query, { isHeader: true });
      delete query.index;
      this.$router.push({ name: 'artwork', query });
    },
  },
};
</script>
